import { Link } from 'react-router-dom';
import { dramas } from '@/mocks/dramas';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function LatestUpdates() {
  const latest = dramas.slice(0, 12);

  return (
    <ScrollReveal>
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
            <i className="ri-time-line text-primary-500 mr-2"></i>
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日更新，追剧不等待</p>
        </div>
        <div className="flex items-center gap-3">
          <button className="text-xs text-foreground-500 hover:text-primary-500 bg-background-200 px-3 py-1.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap">
            最新
          </button>
          <button className="text-xs text-foreground-500 hover:text-primary-500 bg-background-200 px-3 py-1.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap">
            最热
          </button>
          <button className="text-xs text-foreground-500 hover:text-primary-500 bg-background-200 px-3 py-1.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap">
            高分
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {latest.map((drama, i) => (
          <Link
            key={drama.id}
            to={`/article/${drama.id}`}
            className="group flex gap-4 bg-background-50 rounded-xl p-4 border border-background-300/60 hover:border-primary-500/30 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
          >
            <div className="relative rounded-lg overflow-hidden flex-shrink-0" style={{ width: '100px', aspectRatio: '2/3' }}>
              <img
                src={drama.cover}
                alt={drama.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute top-1 left-1">
                <span className="text-[10px] bg-background-900/70 text-foreground-300 px-1.5 py-0.5 rounded">
                  {i + 1}
                </span>
              </div>
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between">
              <div>
                <h3 className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 truncate">
                  {drama.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 leading-relaxed">
                  {drama.description}
                </p>
              </div>
              <div className="flex items-center gap-2 mt-2">
                <span className="text-xs text-primary-500 font-medium">{drama.rating}</span>
                <span className="text-xs text-foreground-600">|</span>
                <span className="text-xs text-foreground-500">{drama.category}</span>
                <span className="text-xs text-foreground-600">|</span>
                <span className="text-xs text-foreground-500">{drama.updateInfo}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
    </ScrollReveal>
  );
}